var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBodyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SELECT-BODY",
    transform: "translate(-242.000000, -15.000000)",
    fill: "currentcolor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(242.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,7.89651407 C21,7.31984745 20.4405684,6.90794273 19.9091083,7.01778399 L15.7972859,7.75921249 C14.8742238,7.92397438 13.9511616,8.00635533 13.0001279,8.00635533 L13.0001279,8.00635533 C12.0770657,8.00635533 11.1260319,7.92397438 10.2029698,7.75921249 L6.14709053,7.01778399 C5.69954523,6.93540304 5.19605677,7.15508556 5.05619887,7.5944506 C4.8603978,8.14365691 5.19605677,8.72032352 5.75548839,8.80270447 L10.6505151,9.70889487 L10.7064582,12.1528629 C10.7624014,13.7455612 10.5666003,15.3382595 10.1749982,16.8760371 L8.94424862,21.6815923 C8.80439071,22.1758779 9.05613494,22.7250842 9.53165182,22.9173064 C10.1470266,23.1644493 10.790373,22.8349255 10.9582024,22.2307986 L12.7483836,15.2284182 C12.8043268,14.9812754 13.1679573,14.9812754 13.2239005,15.2284182 L15.0140817,22.2307986 C15.125968,22.6976239 15.5455417,22.9996874 16.0210586,22.9996874 C16.1888881,22.9996874 16.328746,22.9722271 16.4965755,22.8898461 C16.9441208,22.6701636 17.1399218,22.1758779 17.0280355,21.7090526 L15.7972859,16.8760371 C15.4056838,15.3382595 15.2378543,13.7455612 15.2658259,12.1528629 L15.3217691,9.70889487 L20.1888242,8.83016478 C20.6363694,8.72032352 21,8.33587911 21,7.89651407 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,0 C5.82947368,0 0,5.82947368 0,13 C0,20.1705263 5.82947368,26 13,26 C20.1705263,26 26,20.1705263 26,13 C26,5.82947368 20.1705263,0 13,0 Z M13,24.4126316 C6.70526316,24.4126316 1.58736842,19.2947368 1.58736842,13 C1.58736842,6.70526316 6.70526316,1.58736842 13,1.58736842 C19.2947368,1.58736842 24.4126316,6.70526316 24.4126316,13 C24.4126316,19.2947368 19.2947368,24.4126316 13,24.4126316 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyIcon);
export default __webpack_public_path__ + "static/media/body-icon.80d39e62.svg";
export { ForwardRef as ReactComponent };